import { lazy } from "react";

export const publicRoutes = [
  {
    path: "/login",
    exact: true,
    element: lazy(() => import("./pages/auth/Login")),
  },
  {
    path: "/signup",
    exact: true,
    element: lazy(() => import("./pages/auth/SignUp")),
  },
  {
    path: "/select-supplier",
    exact: true,
    element: lazy(() => import("./pages/SelectSupplier")),
  },
  // {
  //   path: "/forgot-password",
  //   exact: true,
  //   element: lazy(() => import("./pages//auth/ForgotPassword")),
  // },
  // {
  //   path: "/reset-password/:token",
  //   exact: true,
  //   element: lazy(() => import("./pages//auth/ResetPassword")),
  // },
];
export const protectedRoutes = [
  {
    path: "*",
    element: lazy(() => import("./pages/PageNotFound")),
  },

  {
    path: "/tenants",
    exact: true,
    element: lazy(() => import("./pages/tenants")),
  },
  // {
  //   path: "/select-supplier",
  //   exact: true,
  //   element: lazy(() => import("./pages/SelectSupplier")),
  // },
  {
    path: "/users",
    exact: true,
    element: lazy(() => import("./pages/users")),
  },
  {
    path: "/users/create",
    exact: true,
    element: lazy(() => import("./pages/users/UserForm")),
  },
  {
    path: "/users/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/users/UserForm")),
  },
  {
    path: "/profile",
    exact: true,
    element: lazy(() => import("./pages/Profile")),
  },
];
